// Central per-scope catalog for the India / World listing experience.
import { getToursByScope } from "@/data/tours";
import * as I from "@/data/indiaContent";
import * as W from "@/data/worldContent";

const INDIA = {
  scope: "india",
  breadcrumb: "India Tour Packages",
  title: "India Tour Packages",
  intro: I.INDIA_INTRO,
  reviewsLabel: "10,994 Reviews",
  rating: 5,
  allRegionLabel: "All of India",
  ongoing: "6 Tours Ongoing in India right now!",
  packagesNoun: "India Holiday Packages",
  totalCount: 261,
  tours: getToursByScope("india"),
  facets: {
    pricePresets: I.PRICE_PRESETS,
    priceMax: 365000,
    durationPresets: I.DURATION_PRESETS,
    departureCities: I.DEPARTURE_CITIES,
    joiningLeaving: I.JOINING_LEAVING,
    packageTypes: I.PACKAGE_TYPES,
    speciality: I.SPECIALITY_TOURS,
    countries: I.COUNTRIES_FACET,
    cities: I.CITIES_FACET,
    citiesMore: 288,
  },
  toursFrom: null,
  primary: {
    title: "India Tour Packages By City and States",
    tabs: [
      { label: "By City", data: I.BY_CITY },
      { label: "By State", data: I.BY_STATE },
    ],
  },
  regionSection: { title: "India Tour Packages By Zone", data: I.BY_ZONE },
  season: { title: "India Tour Packages By Season", data: I.BY_SEASON },
  interest: { title: "India Tour Packages By Interest", tabs: I.BY_INTEREST_TABS },
  duration: { title: "India Tour Packages By Duration", cards: I.BY_DURATION },
  blogs: { title: "Popular Blogs", data: I.POPULAR_BLOGS },
  reviews: { data: I.TOUR_REVIEWS },
  faqs: I.INDIA_FAQS,
};

const WORLD = {
  scope: "world",
  breadcrumb: "World Tour Packages",
  title: "World Tour Packages",
  intro: W.WORLD_INTRO,
  reviewsLabel: "18,540 Reviews",
  rating: 5,
  allRegionLabel: "All of World",
  ongoing: "10 Tours Ongoing in World right now!",
  packagesNoun: "World Holiday Packages",
  totalCount: 329,
  tours: getToursByScope("world"),
  facets: {
    pricePresets: W.WORLD_PRICE_PRESETS,
    priceMax: 700000,
    durationPresets: W.WORLD_DURATION_PRESETS,
    departureCities: W.WORLD_DEPARTURE_CITIES,
    joiningLeaving: null,
    packageTypes: W.WORLD_PACKAGE_TYPES,
    speciality: W.WORLD_SPECIALITY,
    countries: W.WORLD_COUNTRIES,
    cities: W.WORLD_CITIES,
    citiesMore: 534,
  },
  toursFrom: W.WORLD_TOURS_FROM,
  primary: {
    title: "Explore Best World Tour Packages By Country and Cities",
    tabs: [
      { label: "By Country", data: W.WORLD_BY_COUNTRY },
      { label: "By City", data: W.WORLD_BY_CITY },
    ],
  },
  regionSection: { title: "World Tour Packages By Regions", data: W.WORLD_BY_REGION },
  season: { title: "World Tour Packages By Season", data: W.WORLD_BY_SEASON },
  interest: { title: "World Tour Packages By Interest", tabs: W.WORLD_BY_INTEREST_TABS },
  duration: { title: "Explore Best World Tour Packages By Duration", cards: W.WORLD_BY_DURATION },
  blogs: { title: "Popular Blogs", data: W.WORLD_BLOGS },
  reviews: { data: W.WORLD_REVIEWS },
  faqs: I.INDIA_FAQS,
};

export const REGION_TABS_BY_SCOPE = {
  india: I.REGION_TABS,
  world: W.WORLD_REGION_TABS,
};

export const getCatalog = (scope) => (scope === "world" ? WORLD : INDIA);
